import { LANG } from "@/constants/Language";
import ContentLevel from "@/types/models/ContentLevel.interface";

export const getOriginalLevel = (
  contentLevels: ContentLevel[],
  language: LANG,
) => {
  if (language) {
    return contentLevels.find(
      (level) => level.is_original_level && level.language === language,
    );
  }

  return contentLevels.find((level) => level.is_original_level);
};
